// extracted by mini-css-extract-plugin
export default {"singleSignOn":"SingleSignOnConfig_singleSignOn__KxaHP","welcome":"SingleSignOnConfig_welcome__D4Vdy","disabled":"SingleSignOnConfig_disabled__fExdy"};